var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"languageSelector",attrs:{"id":"setLanguage"}},_vm._l((_vm.languages),function(language){return _c('span',{key:language,on:{"click":function($event){return _vm.switchLanguage(language)}}},[_c('img',{attrs:{"src":_vm.getImagePath(language),"alt":`${_vm.$t('view.index.language-option')}: ${language}`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }